import { MLSID, mlsInfoByShortName } from '@aloft/toolkit-shared';

import { MLS_ID_REGEX } from './consts.js';

export function extractSubjectMLS(doc: Document): { mls?: MLSID; mlsListingID?: string } {
  const latestListingHistory = doc.getElementsByTagName('LISTING_HISTORY')?.[0];
  const prevListingDetails = latestListingHistory?.getAttribute(
    'ListedWithinPreviousYearDescription',
  );

  const matches = prevListingDetails?.match(MLS_ID_REGEX);
  if (matches) {
    const mlsRaw = matches[2];
    const mlsListingID = matches[3];
    const mls = mlsInfoByShortName(mlsRaw)?.mlsid;
    return {
      mls,
      mlsListingID,
    };
  }
  return {};
}
